"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledAccordion = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _AccordionMixin = require("../../mixins/components/AccordionMixin");
var StyledAccordion = /*#__PURE__*/_styledComponents.default.ul.withConfig({
  displayName: "StyledAccordion",
  componentId: "c11n-8-107-0__sc-158b3u3-0"
})(["", ""], _AccordionMixin.AccordionMixin);
exports.StyledAccordion = StyledAccordion;